import { InjectionToken } from '@angular/core';
import { ActivationPricingServiceInterface } from './activation-pricing-service-interface';
import { ActivationServiceInterface } from './activation-service-interface';

export const ActivationServiceInterfaceToken: InjectionToken<ActivationServiceInterface> =
  new InjectionToken<ActivationServiceInterface>('ActivationServiceInterface');
export const ActivationPricingServiceInterfaceToken: InjectionToken<ActivationPricingServiceInterface> =
  new InjectionToken<ActivationPricingServiceInterface>('ActivationPricingServiceInterface');
